import React, { useState } from 'react';
import './App.css';
import jwt_decode from "jwt-decode";
import ReactJson from 'react-json-view'

function App() {
  const [token] = useState<string>('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c')
  const [decoded, setDecoded] = useState<string>(JSON.stringify(jwt_decode(token)));

  const onChangeHandler: React.ChangeEventHandler<HTMLTextAreaElement> = e => {
    try {
      setDecoded(JSON.stringify(jwt_decode(e.target.value)))
    } catch (err) {
      setDecoded(JSON.stringify(err))
    }
  }

  return (
    <div className='bg-white dark:bg-black'>
      <h1 className="ml-10 mt-8 text-3xl font-bold text-slate-800 dark:text-white">JWT decoder</h1>
      <div className="mt-8 ml-8 flex flexr-row gap-16">
        <textarea className='basis-1/4 text-sm' defaultValue={token} autoFocus rows={20} cols={40} onChange={onChangeHandler} />
        <div className='basis-3/4 text-lg'>
          <ReactJson src={JSON.parse(decoded)} />
        </div>
      </div>
    </div>
  );
}

export default App;
